export default __webpack_public_path__ + "static/media/02 - SQL GUI.70a6f437.png";